<template>
    <div class="Traduccion">
        <div class="dropleft" title="Selecciona un idioma">
            <a data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-language" style="color: #ee8813; font-size: 18pt;"></i>
            </a>
            <div class="dropdown-menu">
                <Translator :countries="countries" class="pl-3" />
            </div>
        </div>
    </div>
</template>

<script>
import { Translator } from "vue-google-translate";
export default {
    name: "Traduccion",

    components: {
        Translator
    },

    data() {
        return {
            countries: [
                {
                    code: "en|en",
                    title: "English",
                },
                {
                    code: "en|es",
                    title: "Spanish",
                },
            ],
        }
    },

    mounted() {
        const containers = document.querySelectorAll(".grid");
        if (containers) {
            containers.forEach((container) => {
                container.classList.remove("shadow");
                container.classList.remove("p-4");
                container.classList.remove("m-4");
            });
        }
    },
}
</script>

<style scoped></style>